<template>
  <modal @close="$emit('cancel')">
    <div slot="header"><strong>Confirmation required</strong></div>
    <div slot="body">
      <p>Enter the password to continue.</p>
      <form autocomplete="off" @submit.prevent="$emit('confirm', password)">
        <input
          v-model="password"
          type="password"
          name="action-gate-password"
          class="form-control"
          autocomplete="new-password"
          autofocus
        >
      </form>
      <div class="alert alert-danger mt-3 mb-0" v-if="error">{{ error }}</div>
    </div>
    <div slot="footer">
      <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary" :disabled="loading || !password" @click.prevent="$emit('confirm', password)">Confirm</button>
        <button class="btn btn-outline-primary ml-2" @click.prevent="$emit('cancel')">Cancel</button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  name: 'ActionGateModal',
  components: { Modal },
  props: {
    error: { type: String, default: null },
    loading: { type: Boolean, default: false }
  },
  data() {
    return { password: '' }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ActionGateModal.vue